export interface UpdateCollectionsOrderRequest {
  inputs: {
    orderId: number // TODO 未確認
    holdingBranchCode: string
    buyDepartmentCode: string
    mark: string
    ndc: string
    book: string
    sub: string
    shelfType: string
    collectionType: string
    traderCode: string
    donorCode: string
    orderDate: string
    orderPrice: string
    acceptType: string
    handlingType: string
    appendixCode: string
    revision: number
  }[]
}

export function UpdateCollectionsOrderRequestToJSON(
  value: UpdateCollectionsOrderRequest
): any {
  return {
    inputs: value.inputs.map(input => {
      return {
        order_id: input.orderId !== 0 ? input.orderId : undefined,
        holding_branch_code:
          input.holdingBranchCode !== '' ? input.holdingBranchCode : undefined,
        buy_department_code:
          input.buyDepartmentCode !== '' ? input.buyDepartmentCode : undefined,
        mark: input.mark !== '' ? input.mark : undefined,
        ndc: input.ndc !== '' ? input.ndc : undefined,
        book: input.book !== '' ? input.book : undefined,
        sub: input.sub !== '' ? input.sub : undefined,
        shelf_type: input.shelfType !== '' ? input.shelfType : undefined,
        collection_type:
          input.collectionType !== '' ? input.collectionType : undefined,
        trader_code: input.traderCode !== '' ? input.traderCode : undefined,
        donor_code: input.donorCode !== '' ? input.donorCode : undefined,
        order_date: input.orderDate !== '' ? input.orderDate : undefined,
        order_price: input.orderPrice !== '' ? input.orderPrice : undefined,
        accept_type: input.acceptType !== '' ? input.acceptType : undefined,
        handling_type:
          input.handlingType !== '' ? input.handlingType : undefined,
        appendix_code:
          input.appendixCode !== '' ? input.appendixCode : undefined,
        revision: input.revision !== 0 ? input.revision : undefined
      }
    })
  }
}
